import React, { forwardRef, memo, useState } from 'react';
import PropTypes from 'prop-types';

import styles from '@/views/components/FormInput/FormInput.module.scss';

const FormInput = forwardRef(({ labelValue, inputName, inputType, placeholderValue, error, info, ...props }, ref) => {
	const [ currentInputType, setCurrentInputType ] = useState('password');

	const togglePasswordVisiblity = () => {
		setCurrentInputType(state => {
			if (state === 'password') return 'text';
			return 'password';
		});
	};

	return (
		<div className={ styles['input__container'] }>
			<label 
				htmlFor={ inputName }
				className={ styles['input__label'] }
			>
				{ labelValue }
			</label>
            
			{inputType === 'password' && (
				<div 
					className={ styles['input__password-toggle'] }
					onClick={ togglePasswordVisiblity }
				>
					{currentInputType === 'password' ? <i className='icon-eye' /> : <i className='icon-eye-disabled' /> }
				</div>
			)}

			<input
				ref={ ref }
				id={ inputName }
				name={ inputName }
				type={ inputType === 'password' ? currentInputType : inputType }
				className={ error ? styles['input__item--error'] : styles['input__item'] }
				placeholder={ placeholderValue }
				{ ...props }
			/>
			
			{(info && info.length > 0 && !error) && (
				<div className={ styles["input__info"] }>
					<span>
						<i className='icon-circle-info' />
					</span>
					<span>
						{info}
					</span>
				</div>
			)}
			{error && error.message.length > 0 && (
				<div className={ styles['input__error'] }>
					<span>
						<i className='icon-circle-warning-empty' />
					</span>
					<span>
						{error.message}
					</span>
				</div>
			)}
		</div>
	);
});

FormInput.propTypes = {
	labelValue: PropTypes.string,
	inputName: PropTypes.string,
	inputType: PropTypes.string,
	placeholderValue: PropTypes.string,
	error: PropTypes.object,
	info: PropTypes.string,
};

FormInput.displayName = 'FormInput';

export default memo(FormInput);